// Upload step: pick an audio recording (or use the bundled sample call), then
// hand off to processing. Hybrid demo uses the pre-baked transcript regardless.
//
// Component idiom: the KareHero MUI design system (branded theme), no
// hardcoded colors/radii.

import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { PageHeader } from '@karehero/llama/pwa/atoms/PageHeader/PageHeader';
import { useClaimFlow } from './ClaimFlowContext';
import { SAMPLE_CLIENT } from './fixtures';

export default function Upload() {
  const navigate = useNavigate();
  const { startRun } = useClaimFlow();
  const inputRef = useRef<HTMLInputElement>(null);

  const begin = (name: string) => {
    startRun(name);
    navigate('/aa-claim/processing');
  };

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Container maxWidth='sm' sx={{ py: 6 }}>
        <Button
          variant='text'
          onClick={() => navigate('/aa-claim')}
          sx={{ mb: 2 }}
        >
          ← Back
        </Button>
        <PageHeader
          variant='h4'
          title={`Upload the call with ${SAMPLE_CLIENT.name}`}
          description="Drop in the recording of your Attendance Allowance conversation. We'll transcribe it and fill in the form."
        />

        <Box
          sx={{
            mt: 3,
            p: 5,
            textAlign: 'center',
            bgcolor: 'background.paper',
            border: '1px dashed',
            borderColor: 'divider',
            borderRadius: 1,
          }}
        >
          <input
            ref={inputRef}
            type='file'
            accept='audio/*'
            hidden
            onChange={(e) => {
              const f = e.target.files?.[0];
              if (f) begin(f.name);
            }}
          />
          <Stack sx={{ alignItems: 'center' }} spacing={2}>
            <Typography sx={{ fontSize: 40 }}>🎙️</Typography>
            <Typography>Drag a recording here, or</Typography>
            <Button
              variant='contained'
              onClick={() => inputRef.current?.click()}
            >
              Choose a file
            </Button>
            <Typography variant='body2' color='text.secondary'>
              MP3, M4A or WAV
            </Typography>
          </Stack>
        </Box>

        <Stack sx={{ alignItems: 'center', mt: 3 }}>
          <Button
            variant='text'
            onClick={() => begin(SAMPLE_CLIENT.audioFileName)}
          >
            Use the sample call instead
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
